module.exports = __webpack_public_path__ + "static/img/5_1.ab571afc.jpg";